if (typeof Lenis !== 'undefined') {
  const lenis = new Lenis()

  lenis.on('scroll', (e) => {
    // console.log(e)
  })

  lenis.on('scroll', ScrollTrigger.update)

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000)
  })

  gsap.ticker.lagSmoothing(0)
}


jQuery(document).ready(function ($) {
  $(window).scroll(function () {
    var scrollPos = $(window).scrollTop(),
      navbar = $('.header-wrapper');

    if (scrollPos > 80) {
      navbar.addClass('active-header');
    } else {
      navbar.removeClass('active-header');
    }
  });
});


if (typeof gsap !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger);
  gsap.set(".loader", {
    opacity: 1,
    duration: 1,
    ease: Power3.easeOut
  });


  gsap.registerPlugin(ScrollTrigger);

  let revealContainers = document.querySelectorAll(".reveal");

  revealContainers.forEach(container => {
    let image = container.querySelector("img");
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: container,
        toggleActions: "restart none none reset"
      }
    });



    tl.set(container, { autoAlpha: 1 });
    tl.from(container, 1.5, {
      xPercent: -100,
      ease: Power2.out
    });

    tl.from(image, 1.5, {
      xPercent: 100,
      scale: 1.3,
      delay: -1.5,
      ease: Power2.out
    });

  });
}
// footer contact
var footer_block = document.querySelectorAll(".footer-block");
var footer_block_last = footer_block[3];
var footer_block_lastchild = footer_block_last.lastElementChild;
var footer_block_firstchild = footer_block_last.firstElementChild;
footer_block_firstchild.classList.add("active");
footer_block_lastchild.style.display = "block";